
import { assetworksData } from "game-layers";
import { Gamevy } from "gamevy/gamevy";
import { gamevyModel } from "gamevy/gamevy-model";
import { BoostButtonPosition, PartnerConnectManager } from "partner-connect/partner-connect-manager";
import * as queryString from "query-string";
import { TGRSetup } from "setup/tgr-setup";
import { slotDefinition } from "slotworks/model/slot-definition";
import { ygg } from "ygg/ygg";

PartnerConnectManager.GAME_ID = 10085;
PartnerConnectManager.GAME_NAME = "Tiger Tiger";
PartnerConnectManager.GAME_APP_SRV = "https://dev-nl.yggdrasil.lan";
PartnerConnectManager.COMPANY_NAME = "gamevy";
PartnerConnectManager.EXPECTED_VERSION = { major: 1, minor: 10, patch: 0 }; // Version used during development.
PartnerConnectManager.BOOST_BUTTON_POSITION = BoostButtonPosition.LEFT_CENTER;

declare const __DEBUG__: boolean;
declare const __ENVIRONMENT__: string;
/////////////////////////////////////////////////
/////////////////////////////////////////////////
//////////////////////////////////////////

//////////////////////////////////////////////////////
//////////////////////////////////
//////////////////////////////////////////////////////////////
/////
 
//////////

gamevyModel.gameName = "Tiger Tiger";
gamevyModel.symbolMap.set("S", 0); // scatter
gamevyModel.symbolMap.set("W", 1); // wild
gamevyModel.symbolMap.set("C", 2); // collect
gamevyModel.symbolMap.set("QH", 3); // quick-hit
gamevyModel.symbolMap.set("L1", 4); // L1 A
gamevyModel.symbolMap.set("L2", 5); // L2 K
gamevyModel.symbolMap.set("L3", 6); // L3 Q
gamevyModel.symbolMap.set("L4", 7); // L4 J
gamevyModel.symbolMap.set("L5", 8); // L5 10
gamevyModel.symbolMap.set("H1", 9);  // H1 tiger
gamevyModel.symbolMap.set("H2", 10); // H2 golden tiger
gamevyModel.symbolMap.set("H3", 11); // H3 white tiger
gamevyModel.symbolMap.set("H4", 12); // H4 woman
gamevyModel.symbolMap.set("H5", 13); // H5 blue tiger

ygg.symbolMap.set("S", 0); // scatter
ygg.symbolMap.set("W", 1); // wild
ygg.symbolMap.set("C", 2); // collect
ygg.symbolMap.set("QH", 3); // quick-hit
ygg.symbolMap.set("L1", 4); // L1 A
ygg.symbolMap.set("L2", 5); // L2 K
ygg.symbolMap.set("L3", 6); // L3 Q
ygg.symbolMap.set("L4", 7); // L4 J
ygg.symbolMap.set("L5", 8); // L5 10
ygg.symbolMap.set("H1", 9);  // H1 red tiger
ygg.symbolMap.set("H2", 10); // H2 golden tiger
ygg.symbolMap.set("H3", 11); // H3 white tiger
ygg.symbolMap.set("H4", 12); // H4 woman
ygg.symbolMap.set("H5", 13); // H5 man

slotDefinition.getSymbolDefinition = (id: string) => {
    id = id.replace(/^QH_.*/, "QH");
    for (const symbol of slotDefinition.symbolDefinitions) {
        if (symbol.id === id || symbol.aliases.indexOf(id) > -1) {
            return symbol;
        }
    }
    throw new Error("Symbol not found in symbol definitions: " + id);
};

PartnerConnectManager.load().then(() => {
    gamevyModel.disableRulesCheckError = true;

    Gamevy.go(new TGRSetup(), assetworksData, {
        customLayout: true,
        noMenuButton: true,
        noBottomBar: true
    });
});
